import type { PlanStatus } from '@vy/types';
import { PLAN_STATUSES, PlanStatusSchema } from '@vy/types';
import { useStateParams } from '../../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../../utils/params-formatting';

export function usePlansOverviewsStatusesParam() {
  return useStateParams<PlanStatus[]>(
    [PLAN_STATUSES.Active],
    'plansStatuses',
    serializeStringArrayParam,
    deserializePlansOverviewsStatusArrayParam,
  );
}

function deserializePlansOverviewsStatusArrayParam(
  plansOverviewsStatusesArrayStringified: string,
): PlanStatus[] | null {
  const statuses = plansOverviewsStatusesArrayStringified.split(',');

  return statuses.map((status) => {
    return PlanStatusSchema.parse(status);
  });
}
